import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';

import { appInsights } from '../../../auth/appInsight';
import { getStringProduct } from '../../../utils/utilityFunctions';

const TypographyText = styled('p')(({ theme, color, textshadow, fontsize, fontweight, lineheight, textalign, padding, xllfontsize, xllineheight, margin, texttransform, fontstyle }) => ({
  fontFamily: 'Poppins',
  fontStyle: 'normal',
  fontWeight: fontweight || 500,
  fontSize: fontsize || '12px',
  lineHeight: lineheight || '24px',
  textAlign: textalign || 'center',
  color: color || theme.palette.text.primary,
  textShadow: textshadow || '',
  margin: margin || '0px 0px 0px 0px',
  padding: padding || 0,
  fontStyle: fontstyle || 'normal',
  textTransform: texttransform || 'capitalize',
  [theme.breakpoints.up('xll')]: {
    fontSize: getStringProduct(1.25, fontsize || '15px'),
    margin: getStringProduct(1.25, margin || '0px 0px 0px 0px'),
    padding: getStringProduct(1.25, padding || 0),
    lineHeight: getStringProduct(1.25, lineheight || '24px')
    // lineHeight: '18px'
  },
  [theme.breakpoints.up('xlll')]: {
    fontSize: getStringProduct(1.66, fontsize || '15px'),
    margin: getStringProduct(1.66, margin || '0px 0px 0px 0px'),
    padding: getStringProduct(1.66, padding || 0),
    lineHeight: getStringProduct(1.66, lineheight || '24px')
    // lineHeight: '18px'
  },

  [theme.breakpoints.up('xl4')]: {
    fontSize: getStringProduct(2.46, fontsize || '15px'),
    padding: getStringProduct(2.46, padding || 0),
    lineHeight: getStringProduct(2.46, lineheight || 'normal'),
    margin: getStringProduct(2.46, margin || '0px 0px 0px 0px')
  }
}));
const FreedomTypographyText = (props) => {
  const { children, color, textshadow, fontsize, xllfontsize, fontweight, lineheight, xllineheight, textalign, margintop, marginright, texttransform, fontstyle, ...rest } = props;
  try {
    return (
      <TypographyText
        style={{ marginTop: margintop, marginRight: marginright }}
        color={color}
        fontsize={fontsize}
        fontweight={fontweight}
        lineheight={lineheight}
        xllfontsize={xllfontsize}
        xllineheight={xllineheight}
        textalign={textalign}
        textshadow={textshadow}
        texttransform={texttransform}
        fontstyle={fontstyle}
        {...rest}
      >
        {children}
      </TypographyText>
    );
  } catch (error) {
    appInsights.trackException({ error: new Error(error) });
  }
};

export default FreedomTypographyText;

FreedomTypographyText.propTypes = {
  color: PropTypes.string,
  fontsize: PropTypes.string,
  fontWeight: PropTypes.number,
  lineHeight: PropTypes.string,
  textAlign: PropTypes.string
};
